import React from 'react';
import { ROUTE_GROUPS, ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';
import { AsyncGlobalAppsSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-global-settings-apps-settings';
import {
	AsyncGlobalIssuesSettingsSidebar,
	ISSUES_SETTINGS_ROUTE_NAMES,
} from '@atlassian/jira-navigation-apps-sidebar-nav4-global-settings-issues-settings';
import { AsyncGlobalProductsSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-global-settings-products-settings';
import {
	AsyncGlobalProjectsSettingsSidebar,
	PROJECTS_SETTINGS_ROUTE_NAMES,
} from '@atlassian/jira-navigation-apps-sidebar-nav4-global-settings-projects-settings';
import { AsyncGlobalSystemSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-global-settings-system-settings';
import { AsyncPlanSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-plan-settings';
import { AsyncJpdProjectSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-project-settings-jpd-settings';
import { AsyncJsmProjectSettingsSidebar } from '@atlassian/jira-navigation-apps-sidebar-nav4-project-settings-jsm-settings';
import AsyncSidebarContent from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebar-content/src/async';
import { useCurrentRoute, usePathParam } from '@atlassian/jira-platform-router-utils';

export const SidebarSelector = () => {
	const route = useCurrentRoute();
	const [section] = usePathParam('section');

	switch (route.group) {
		case ROUTE_GROUPS.PROJECT_SETTINGS_SERVICEDESK:
			return <AsyncJsmProjectSettingsSidebar />;
		default: // Do nothing
	}

	if (PROJECTS_SETTINGS_ROUTE_NAMES.has(route.name)) {
		return <AsyncGlobalProjectsSettingsSidebar />;
	}

	if (ISSUES_SETTINGS_ROUTE_NAMES.has(route.name)) {
		return <AsyncGlobalIssuesSettingsSidebar />;
	}

	switch (route.name) {
		case ROUTE_NAMES.MARKETPLACE_INDEX:
			return <AsyncGlobalAppsSettingsSidebar />;
		case ROUTE_NAMES.PRODUCTS_JSW_CONFIGURATION:
			return <AsyncGlobalProductsSettingsSidebar />;
		case ROUTE_NAMES.SYSTEM_CONFIGURATION:
			return <AsyncGlobalSystemSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_PERMISSIONS:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_PLAN_INFO:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_SCENARIOS:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.SOFTWARE_PLAN_SETTINGS_SCHEDULING:
			return <AsyncPlanSettingsSidebar />;
		case ROUTE_NAMES.POLARIS_IDEAS:
			if (section === 'settings') {
				return <AsyncJpdProjectSettingsSidebar />;
			}
			return <AsyncSidebarContent />;
		default:
			return <AsyncSidebarContent />;
	}
};
